import { RoadmapItemSourceType } from "../../../../../customer-experience/src/lib/ShiOneClient";
import { RecommendationTypeHandler } from "./types";

class RecommendationTypeRegistry {
  private handlers = new Map<
    RoadmapItemSourceType,
    RecommendationTypeHandler
  >();

  register(handler: RecommendationTypeHandler): void {
    this.handlers.set(handler.sourceType, handler);
  }

  getHandler(
    sourceType: RoadmapItemSourceType,
  ): RecommendationTypeHandler | undefined {
    return this.handlers.get(sourceType);
  }

  getHandlerForRecommendation(
    recommendation: any,
  ): RecommendationTypeHandler | undefined {
    for (const handler of this.handlers.values()) {
      if (handler.isType(recommendation)) {
        return handler;
      }
    }
    return undefined;
  }

  getAllHandlers(): RecommendationTypeHandler[] {
    return Array.from(this.handlers.values());
  }

  getDisplayConfig(sourceType: RoadmapItemSourceType) {
    return this.handlers.get(sourceType)?.displayConfig;
  }

  getDetailDialog(sourceType: RoadmapItemSourceType) {
    return this.handlers.get(sourceType)?.detailDialog;
  }

  getAdapter(sourceType: RoadmapItemSourceType) {
    return this.handlers.get(sourceType)?.adapter;
  }

  getHandlersWithSourceSections(): RecommendationTypeHandler[] {
    return Array.from(this.handlers.values()).filter(
      (handler) => handler.sourceSection,
    );
  }

  getSourceSection(sourceType: RoadmapItemSourceType) {
    return this.handlers.get(sourceType)?.sourceSection;
  }

  getListItemContent(recommendation: any) {
    const handler = this.getHandlerForRecommendation(recommendation);
    return handler?.getListItemContent?.(recommendation);
  }

  getChipLabel(recommendation: any) {
    const handler = this.getHandlerForRecommendation(recommendation);
    return handler?.getChipLabel?.(recommendation);
  }

  getGroupKey(recommendation: any, context?: { assessments?: any[] }) {
    const handler = this.getHandlerForRecommendation(recommendation);
    return handler?.getGroupKey?.(recommendation, context) || "unknown";
  }

  getGroupTitle(
    groupKey: string,
    sourceType?: RoadmapItemSourceType,
    context?: { assessments?: any[] },
  ) {
    if (sourceType) {
      const handler = this.handlers.get(sourceType);
      return handler?.getGroupTitle?.(groupKey, context) || groupKey;
    }

    for (const handler of this.handlers.values()) {
      const title = handler.getGroupTitle?.(groupKey, context);
      if (title && title !== groupKey) {
        return title;
      }
    }
    return groupKey;
  }

  getListItemAdditionalContent(recommendation: any) {
    const handler = this.getHandlerForRecommendation(recommendation);
    return handler?.ListItemAdditionalContent;
  }
}

export const recommendationRegistry = new RecommendationTypeRegistry();
